import { ImageSearchStateType, SearchImageSetPayload } from "@type/index";
import { fileToBase64 } from "@util/common";
import { ActionsUnion, createAction } from "../helpers";
// set img page search param
export const SET_SEARCH_IMAGE = "[image search] SET PARAM";
export const CLEAR_SEARCH_IMAGE = "[image search] CLEAR PARAM";
export const SET_CLICK_UPLOAD_IMAGE = "[image search] SET CLICK UPLOAD IMAGE";
export const SET_UPLOAD_IMAGE_LOADING =
  "[image search] SET UPLOAD IMAGE LOADING";

export const Actions = {
  setSearchImage: (payload: SearchImageSetPayload) =>
    createAction(SET_SEARCH_IMAGE, payload),
  clearSearchImage: () => createAction(CLEAR_SEARCH_IMAGE),
  setClickUploadImage: (payload: boolean) =>
    createAction(SET_CLICK_UPLOAD_IMAGE, payload),
  setUploadImageLoading: (payload: boolean) =>
    createAction(SET_UPLOAD_IMAGE_LOADING, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

const initialState: ImageSearchStateType = {
  image: null,
  isClickUploadImage: false,
  isUploadImageLoading: false
};

export default (
  state: ImageSearchStateType = initialState,
  action: ActionType
): ImageSearchStateType => {
  switch (action.type) {
    case SET_SEARCH_IMAGE: {
      fileToBase64(action.payload.image).then((baseFile) => {
        window.localStorage.setItem("searchImage", baseFile);
      });
      return { ...state, image: action.payload.image };
    }
    case CLEAR_SEARCH_IMAGE: {
      return {
        ...state,
        image: null,
        isClickUploadImage: false,
        isUploadImageLoading: false
      };
    }
    case SET_CLICK_UPLOAD_IMAGE: {
      return { ...state, isClickUploadImage: action.payload };
    }
    case SET_UPLOAD_IMAGE_LOADING: {
      return { ...state, isUploadImageLoading: action.payload };
    }
    default:
      return state;
  }
};
